/**
 * herd
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 0.220.0-SNAPSHOT
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { JdbcStatementResultSet } from './jdbcStatementResultSet';


export interface JdbcStatement { 
    type: JdbcStatement.TypeEnum;
    sql: string;
    continueOnError?: boolean;
    status?: JdbcStatement.StatusEnum;
    result?: string;
    resultSet?: JdbcStatementResultSet;
    errorMessage?: string;
}
export namespace JdbcStatement {
    export type TypeEnum = 'UPDATE' | 'QUERY';
    export const TypeEnum = {
        UPDATE: 'UPDATE' as TypeEnum,
        QUERY: 'QUERY' as TypeEnum
    };
    export type StatusEnum = 'SUCCESS' | 'ERROR' | 'SKIPPED';
    export const StatusEnum = {
        SUCCESS: 'SUCCESS' as StatusEnum,
        ERROR: 'ERROR' as StatusEnum,
        SKIPPED: 'SKIPPED' as StatusEnum
    };
}
